import IComponentSelectProps from 'interfaces/IComponentSimpleProps';

import { ReduxStore } from 'store/types';

function getAllToSelect(store: ReduxStore): IComponentSelectProps[] {
  return store.category.getAllToSelect.list;
}

export default getAllToSelect;
